mutation UserTemplateCopy($input: UserTemplateCopyInput!) {
  userTemplateCopy(input: $input) {
    clientMutationId
  
  }
}